import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import pattern from '../../assets/images/pattern.jpg';
import logo from '../../assets/images/logo.png';
import ROUTE from '../../constants/route';
import {Role} from '../../helpers/user';

import SvgButton from '../SvgButton';

import Links from './schema';
import './styles.css';

const Footer = props => {
  const { user } = props;

  const footerNavs = useMemo(() => {
    const isCandidate = Role.isCandidate(user);

    const handleLinkClick = () => {
      Role.isCandidate(user, true);
      document.activeElement.blur();
    };

    return Links.map((nav, i) => (
      <div className="footer__nav" key={i}>
        <h3 className="footer__nav-title">{nav.title}</h3>
        <ul className="footer__nav-list">
          {nav.items
            .filter(link =>
              user.isLoggedIn ? !link.anonymousOnly : !link.candidateOnly
            )
            .map((link, j) => (
              <li className="footer__nav-item" key={j}>
                {link.href ? (
                  <a className="footer__nav-link" href={link.href}>
                    {link.text}
                  </a>
                ) : link.to === ROUTE.CANDIDATE_UPGRADE_PREMIUM ? (
                  Role.isCandidate(user) &&
                  !Role.isRecruiter(user) &&
                  (!Role.isCandidatePremium(user) ||
                    !Role.isCandidatePremiumWithPrep(user)) ? (
                    <Link className="footer__nav-link" to={link.to}>
                      {link.text}
                    </Link>
                  ) : null
                ) : (
                  <Link
                    className="footer__nav-link"
                    to={isCandidate ? link.to : '#'}
                    onClick={handleLinkClick}
                  >
                    {link.text}
                  </Link>
                )}
              </li>
            ))}
        </ul>
      </div>
    ));
  }, [user]);

  return (
    <footer
      className="footer"
      style={{ backgroundImage: 'url(' + pattern + ')' }}
    >
      <div className="container">
        <div className="footer__top">
          <div className="footer__company-info">
            <a className="footer__logo" href="/">
              <img className="footer__logo-img" src={logo} alt="GoBuyside" />
            </a>

            <SvgButton
              btnWidth={200}
              btnFontWeight={600}
              btnHeight={40}
              btnHref="/contact"
              btnText="Contact Us"
              btnArrow={true}
            />
          </div>
          <div className="footer__navs">{footerNavs}</div>
        </div>

        <div className="footer__bottom">
          <div className="footer__legal-links">
            <a href="/privacy" className="footer__legal-link">
              Privacy Policy
            </a>
            <a href="/terms" className="footer__legal-link">
              Terms of Use
            </a>

            <div className="footer__icon-links">
              <a
                className="footer__icon-link footer__icon-link--linkedin icon-soc-linkedin"
                target={'_blank'}
                href="https://www.linkedin.com/company/gobuyside"
              >{``}</a>
              <a
                className="footer__icon-link footer__icon-link--envelope icon-soc-email"
                target={'_blank'}
                href="mailto:firms@gobuyside.com?subject=GoBuyside Inquiry"
              >{``}</a>
            </div>
          </div>

          <div className="footer__copyright">
            GoBuyside LLC. © {new Date().getFullYear()} – All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
